// Centralized TanStack Query key builders. Kept in one place so the
// WebSocket event handler (hooks/use-mailbox-socket.ts) can invalidate the
// right query groups by partial-key prefix match without every hook having
// to agree on shape by convention alone.
export const mailboxQueryKeys = {
  folders: (mailboxId: string) => ["mailbox", mailboxId, "folders"] as const,
  threads: (mailboxId: string, folderSlug: string) => ["mailbox", mailboxId, "threads", folderSlug] as const,
  threadsAll: (mailboxId: string) => ["mailbox", mailboxId, "threads"] as const,
  thread: (mailboxId: string, threadId: string) => ["mailbox", mailboxId, "thread", threadId] as const,
  threadAll: (mailboxId: string) => ["mailbox", mailboxId, "thread"] as const,
  search: (mailboxId: string, q: string) => ["mailbox", mailboxId, "search", q] as const,
  permissions: (mailboxId: string) => ["mailbox", mailboxId, "permissions"] as const,
  contacts: (mailboxId: string, q: string) => ["mailbox", mailboxId, "contacts", q] as const,
};

/** Cross-mailbox (Phase 5) query keys — deliberately not under the "mailbox" prefix above since they don't scope to one mailbox. */
export const aggregateQueryKeys = {
  threads: (folderSlug: string) => ["aggregate", "threads", folderSlug] as const,
};
